// © Microsoft Corporation. All rights reserved.

import { canUseDOM } from "@msnews/isomorphic-util";

const pageTimings = canUseDOM() ? (window._pageTimings || (window._pageTimings = {})) : {};
const secondaryPageTimings = canUseDOM() ? (window._secondaryPageTimings || (window._secondaryPageTimings = {})) : {};

/**
 * Gets current window._pageTimings object
 */
export function getPageTimings(): object {
    return pageTimings;
}

/**
 * Gets current window._secondaryPageTimings object
 */
export function getSecondaryPageTimings(): object {
    return secondaryPageTimings;
}

/**
 * Creates or updates a new counter under the page timings
 * @param counterName - the name of the counter to increment.
 */
export function incrementCounter(counterName: string): void {
    if (counterName && pageTimings) {
        const existingCount = pageTimings[counterName] || (pageTimings[counterName] = 0);
        pageTimings[counterName] = existingCount + 1;
    }
}

/**
 * Reset pageTimings object
 */
export function resetPageTimings(): void {
    Object.keys(pageTimings).forEach(key => delete pageTimings[key]);
    Object.keys(secondaryPageTimings).forEach(key => delete secondaryPageTimings[key]);
}
